import { render, staticRenderFns } from "./LabelFilterEditor.vue?vue&type=template&id=c60228f0"
import script from "./LabelFilterEditor.vue?vue&type=script&lang=ts"
export * from "./LabelFilterEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports